<template>
  <div class="product">
    <headers></headers>
    <div class="product-info1">
      <el-row>
        <el-col :span="24">
          <div class="tt">
            关于经理云
            <p>Abous us</p>
          </div>
        </el-col>
      </el-row>
      <img src="../assets/images/about/about1 (4).png" alt />
      <div class="product-info1-info1">
        <div class="product-info1-info2">
          <img src="../assets/images/about/about1 (3).png" alt />
        </div>
        <div class="product-info1-info3">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九洲云联是一家集软件研制开发、支持、营销、施工安装、及售后服务为一体的高新技术公司。公司专注于行业应用领域的无线网关产品开发、无线交换机、应用服务器、远程控制、智能化小区建设的技术开发、产品研发、应用系统集成、生产销售等业务。
          <p>&nbsp;</p>
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九洲云联（武汉）作为九洲云联旗下公司，结合当代移动互联网大力发展的趋势下，致力于经理云生态管理平台的研究，专注增值数据挖掘服务，为多结构化眼镜商家提供一整套包含零售店管理、ERP库存管理在内的生态管理系统，同时实现店铺管理、人员管理、订单管理、报表管理、广告管理和财务管理等。
          <p>&nbsp;</p>
          <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未来，九洲云联经理云将多渠道的整合资料，多角度的学习和实践，最大化的实现本公司产品的价值——成为用户们最满意的收银机服务提供商，同时你们的支持和认可也是推进我们不断前行的动力。
          <br />
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="small-info1">
      <img src="../assets/images/about/about1 (4).png" width="100%" alt />
      <div
        class="small-info1-info"
      >九洲云联经理云，作为九洲云联集团旗下公司,定位于智能系统提供商,专注增值数据挖掘服务，为实体业商家提供一整套零售店管理、ERP系统,实现商品可追溯管控，店务、考勤、报表、会员管理等,并且提供配套营销解决方案在移动办公，移动互联网大力发展的趋势下，公司结合互联网思维，研发出云服务平台，为实体店商家老板提供一整套系统的零售店管理、营销、财务解决方案。解放老板的同时，方便管理，又能提高实体业在管理和营销效率。未来，九洲云联经理云将整合企业及产品优势，与广大客户以及合作伙伴一道，携手共进。努力把公司打造成国内最具实力和竞争力的收银管理软件供应商和咨询服务商。我们的目标是：努力成为所有用户最满意的收银机服务提供商，我们相信有您的支持我们会做的更好。</div>
    </div>
    <div class="product-info2">公司机会</div>
    <div class="product-info3">Corporate Opportunities</div>
    <div class="bigbox">
      <div class="product-info4">
        <img src="../assets/images/about/about1 (1).png" alt />
      </div>
      <div class="dispose-info8">
        <div @mouseover="flag=1" :class="flag ==1 ? 'isactive' : ''">UI设计狮</div>
        <div @mouseover="flag=2" :class="flag ==2 ? 'isactive' : ''">java攻城狮</div>
        <div @mouseover="flag=3" :class="flag ==3 ? 'isactive' : ''">Andriod攻城狮</div>
        <div @mouseover="flag=4" :class="flag ==4 ? 'isactive' : ''">前端攻城狮</div>
      </div>
      <el-row class="zhaoping">
        <el-col :span="16" :offset="4">
          <div class="xiaobox" :style="flag ==1 ? 'display:block' : 'display:none' ">
            <h3>UI设计师</h3>
            <h4>岗位描述</h4>
            <p>1.硬性要求：有销售经验或者文笔好 有文案经验。</p>
            <p>2.负责公司产品的用户体验设计，其中主要包含视觉、用户研究及品牌风格方向等。</p>
            <p>3.配合产品经理、开发人员进行页面布局和效果的整体实现。</p>
            <p>4.关注并分析同行业产品，体验产品细节，持续优化升级界面视觉设计及用户体验。</p>
            <h4>任职资格：</h4>
            <p>1. 具有专科及以上学历，美术、设计、工业设计或相关专业</p>
            <p>2. 熟练运用相关的设计制作软件：Sketch、Photoshop、Illustrator</p>
            <p>3.具备良好合作态度及团队精神，并富有工作激情、创造力和责任感</p>
          </div>
          <div class="xiaobox" :style="flag ==2 ? 'display:block' : 'display:none' ">
            <h3>java工程师</h3>
            <h4>任职资格：</h4>
            <p>1、一年以上Java WEB应用系统开发工作经验，熟悉J2EE技术框架；</p>
            <p>2、掌握Java、Jsp、Servlet、JavaBean、XML、JavaScript、**BC等WEB应用开发技术；</p>
            <p>3、熟悉面向对象编程技术，熟悉主要的设计模式；</p>
            <p>4、熟悉主流数据库系统的使用，如：Oracle、MSSQLServer、MySQL等；</p>
            <p>5、熟悉Tomcat、Websphere等应用服务器技术及Eclipse等开发工具；</p>
            <p>6、有良好的自学能力，独立思考能力，能够在短时间内学习并应用新技术；</p>
            <p>7、有强烈的责任心，良好的沟通能力和良好的团队合作精神。</p>
          </div>
          <div class="xiaobox" :style="flag ==3 ? 'display:block' : 'display:none' ">
            <h3>安卓工程师</h3>
            <h4>任职资格：</h4>
            <p>1、有专业的技术知识经验；</p>
            <p>2、熟悉Android开发平台及框架原理，了解Android NDK开发；</p>
            <p>3、熟悉Android安全认证机制（签名、证书校验机制），熟悉常见的加密、解密机制的原理和实用技术；</p>
            <p>4、有实际的Android app性能调优经验；</p>
            <p>5、思路清晰，善于思考，责任心强，有灵活性，有创造力；善于沟通，具备较强的团队协作意识和能力；</p>
            <p>6、能力优秀者可适当放宽条件，接受应届毕业生（待遇从优）。</p>
          </div>
          <div class="xiaobox" :style="flag ==4 ? 'display:block' : 'display:none' ">
            <h3>前端工程师</h3>
            <h4>任职资格：</h4>
            <p>1、2年以上互联网前端开发经验（能力优秀者可适当放宽条件）；</p>
            <p>2、基本功扎实，能够高保真还原设计稿，代码风格严谨工整，能够兼容各种浏览器和设备，精通熟悉Html5，Css3，Es5,Es6,Sass,Jquery等；</p>
            <p>3、对前端MV*框架有深刻理解，Vuejs、AngularJS、React至少熟练一个，并有相关的项目经验；</p>
            <p>4、熟悉掌握 Webpack, Gulp, Browserify等前端构建工具， 对于前端模块化及工程化有所了解；熟悉AJAX/JSON 技术和数据交换格式，和后端实现良好的交互；</p>
            <p>5、熟悉http，熟悉各种浏览器终端的兼容性，对Web前台的性能优化以及Web常见漏洞有一定的理解和相关实践；</p>
            <p>6、有weex、hybrid、react native等混合app开发经验者优先。</p>
          </div>
        </el-col>
      </el-row>
      <div class="dispose-info88">
        立即加入
        <p>
          请将简历发送至:
          <br />hr01@cnc-lick.com
        </p>
      </div>
    </div>
    <div class="smallbox">
      <h2>招聘</h2>
      <div class="smallbox-info">
        <div class="smallbox-info-t">
          <img src="../assets/images/about/ui.png" alt />
          <span>UI设计</span>
        </div>
        <div class="smallbox-info-b">
          <b>UI设计</b>
          <br />
          <b>岗位描述</b>
          <p>1.硬性要求：有销售经验或者文笔好 有文案经验。</p>
          <p>2.负责公司产品的用户体验设计，其中主要包含视觉、用户研究及品牌风格方向等。</p>
          <p>3.配合产品经理、开发人员进行页面布局和效果的整体实现。</p>
          <p>4.关注并分析同行业产品，体验产品细节，持续优化升级界面视觉设计及用户体验。</p>
        </div>
      </div>
      <div class="smallbox-info">
        <div class="smallbox-info-t">
          <img src="../assets/images/about/java.png" alt />
          <span>java</span>
        </div>
        <div class="smallbox-info-b">
          <b>UI设计</b>
          <br />
          <b>任职资格：</b>
          <p>1、一年以上Java WEB应用系统开发工作经验，熟悉J2EE技术框架；</p>
          <p>2、掌握Java、Jsp、Servlet、JavaBean、XML、JavaScript、**BC等WEB应用开发技术；</p>
          <p>3、熟悉面向对象编程技术，熟悉主要的设计模式；</p>
          <p>4、熟悉主流数据库系统的使用，如：Oracle、MSSQLServer、MySQL等；</p>
          <p>5、熟悉Tomcat、Websphere等应用服务器技术及Eclipse等开发工具；</p>
          <p>6、有良好的自学能力，独立思考能力，能够在短时间内学习并应用新技术；</p>
          <p>7、有强烈的责任心，良好的沟通能力和良好的团队合作精神。</p>
        </div>
      </div>
      <div class="smallbox-info">
        <div class="smallbox-info-t">
          <img src="../assets/images/about/android.png" alt />
          <span>安卓</span>
        </div>
        <div class="smallbox-info-b">
          <b>安卓工程师</b>
          <br />
          <b>任职资格：</b>
          <p>1、有专业的技术知识经验；</p>
          <p>2、熟悉Android开发平台及框架原理，了解Android NDK开发；</p>
          <p>3、熟悉Android安全认证机制（签名、证书校验机制），熟悉常见的加密、解密机制的原理和实用技术；</p>
          <p>4、有实际的Android app性能调优经验；</p>
          <p>5、思路清晰，善于思考，责任心强，有灵活性，有创造力；善于沟通，具备较强的团队协作意识和能力；</p>
          <p>6、能力优秀者可适当放宽条件，接受应届毕业生（待遇从优）。</p>
        </div>
      </div>
      <div class="smallbox-info">
        <div class="smallbox-info-t">
          <img src="../assets/images/about/ios.png" alt />
          <span>前端</span>
        </div>
        <div class="smallbox-info-b">
          <b>前端工程师</b>
          <br />
          <b>任职资格：</b>
          <p>1、2年以上互联网前端开发经验（能力优秀者可适当放宽条件）；</p>
          <p>2、基本功扎实，能够高保真还原设计稿，代码风格严谨工整，能够兼容各种浏览器和设备，精通熟悉Html5，Css3，Es5,Es6,Sass,Jquery等；</p>
          <p>3、对前端MV*框架有深刻理解，Vuejs、AngularJS、React至少熟练一个，并有相关的项目经验；</p>
          <p>4、熟悉掌握 Webpack, Gulp, Browserify等前端构建工具， 对于前端模块化及工程化有所了解；熟悉AJAX/JSON 技术和数据交换格式，和后端实现良好的交互；</p>
          <p>5、熟悉http，熟悉各种浏览器终端的兼容性，对Web前台的性能优化以及Web常见漏洞有一定的理解和相关实践；</p>
          <p>6、有weex、hybrid、react native等混合app开发经验者优先。</p>
        </div>
      </div>
    </div>

    <div class="shili">
      <div class="dispose-info888">
        <div class="product-info2">团队实力</div>
        <div class="product-info3">Team strength</div>
      </div>
      <div class="dispose-info9">
        <ul>
          <li>
            <div>
              <img src="../assets/images/about/about3.png" alt />
            </div>
            <h5>专业——研发</h5>
            <p>经理云拥有一支年轻而优秀的研发团队</p>
          </li>
          <li>
            <div>
              <img src="../assets/images/about/about1.png" style="height:80px" alt />
            </div>
            <h5 style=" margin-bottom: 30px;">细致——服务</h5>
            <p>我们不做产品</p>
            <p>我们是眼镜行业解决方案提供商</p>
          </li>
          <li>
            <div>
              <img src="../assets/images/about/about2.png" style="height:86px" alt />
            </div>
            <h5>极致——发展</h5>
            <p>科学技术是第一生产力</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="smallshili">
      <h2>团队实例</h2>
      <div class="swiper-container1">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="slidebox">
              <p>
                <img src="../assets/images/about/about3.png" alt />
              </p>
              <p>专业——研发</p>
              <p>经理云拥有一支年轻而优秀的研发团队</p>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slidebox">
              <p>
                <img src="../assets/images/about/about1.png" alt />
              </p>
              <p>细致——服务</p>
              <p>我们是眼镜行业解决方案提供商</p>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slidebox">
              <p>
                <img src="../assets/images/about/about2.png" alt />
              </p>
              <p>极致——发展</p>
              <p>科学技术是第一生产力</p>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

    <div class="dispose-info8"></div>
    <div class="product-info2" style="font-size:36px;margin-bottom:10px;">联系我们</div>
    <div class="product-info3" style="font-size:24px;font-weight: 400">Contact us</div>
    <div class="dispose-info10">
      <div class="dispose-info11">
        <!-- <img src="../assets/images/about/about1 (2).png" width="680px" alt /> -->
        <!-- <baidu-map class="bm-view"></baidu-map> -->
        <baidu-map
          class="bm-view"
          center="武汉市江汉区"
          :zoom="zoom"
          ak="L1jwbFNnXQ9yZ7LWtAgUcQ2wC5keEmbz"
        >
          <!-- <bm-local-search :keyword="keyword" :auto-viewport="true" :location="location" :selectFirstResult="true" :panel="true"></bm-local-search> -->
          <bm-marker :position="{lng: 114.300577, lat: 30.575322}" @click="infoWindowOpen">
            <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
              <div id="connnnnn" style="margin:0;line-height:20px;padding:2px;font-size:12px;">
                <h4 style="margin-bottom:10px;">
                  九州云联(武汉)科技有限公司
                  <a
                    href="http://map.baidu.com/detail?qt=ninf&uid=803708f10e36e507018972db&detail=house"
                  >详情>></a>
                </h4>地址：湖北省武汉市江汉区沿江大道民权路1号长江大厦5楼
                <br />公司电话： 027-65389618
                <br />公司邮箱： hr@cnc-link.com
                <br />简介：九洲云联(武汉)科技有限公司综合研发及办公总部。
              </div>
            </bm-info-window>
          </bm-marker>,
        </baidu-map>
      </div>
      <div class="dispose-info11">
        <p>九洲云联（武汉）科技有限公司鄂 ICP备 16018492号</p>
        <p>电话：027-65389618</p>
        <p>邮箱：hr@cnc-link.com</p>
        <p>地址：湖北省武汉市江汉区沿江大道民权路1号长江大厦5楼</p>
        <p>Copyright © 2015-2019 CNC-LINK All Right Reserved.</p>
      </div>
    </div>

    <!-- 移动端地图 -->
    <div class="smallmap">
      <h2>联系我们</h2>
      <baidu-map class="bm-view" center="武汉市江汉区" :zoom="zoom" ak="L1jwbFNnXQ9yZ7LWtAgUcQ2wC5keEmbz">
        <!-- <bm-local-search :keyword="keyword" :auto-viewport="true" :location="location" :selectFirstResult="true" :panel="true"></bm-local-search> -->
        <bm-marker :position="{lng: 114.300577, lat: 30.575322}" @click="infoWindowOpen">
          <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">
            <div id="connnnnn" style="margin:0;line-height:20px;padding:2px;font-size:12px;">
              <h4 style="margin-bottom:10px;">
                九州云联(武汉)科技有限公司
                <a
                  href="http://map.baidu.com/detail?qt=ninf&uid=803708f10e36e507018972db&detail=house"
                >详情>></a>
              </h4>地址：湖北省武汉市江汉区沿江大道民权路1号长江大厦5楼
              <br />公司电话： 027-65389618
              <br />公司邮箱： hr@cnc-link.com
              <br />简介：九洲云联(武汉)科技有限公司综合研发及办公总部。
            </div>
          </bm-info-window>
        </bm-marker>
      </baidu-map>
    </div>
    <footers style="margin-top:110px"></footers>
  </div>
</template>

<script>
import footer from "../components/footer";
import header from "../components/headers";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import Swiper from "swiper";
import "../../node_modules/swiper/dist/css/swiper.min.css";
export default {
  name: "",
  components: {
    footers: footer,
    headers: header,
    BaiduMap
  },
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 12,
      keyword: "长江大厦",
      location: "武汉",
      show: true,
      flag: 1
    };
  },
  mounted() {
    var mySwiper = new Swiper(".swiper-container1", {
      pagination: {
        el: ".swiper-pagination"
      },
      slidesPerView: 2
    });
  },
  methods: {
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}
.product {
  width: 100%;
  @media screen and (max-width: 850px) {
    .product-info1 {
      display: none;
    }
    .bigbox {
      display: none;
    }
    .shili {
      display: none;
    }
    .dispose-info10 {
      display: none !important;
    }
  }
  @media screen and (min-width: 850px) {
    .small-info1 {
      display: none;
    }
    .smallbox {
      display: none;
    }
    .smallshili {
      display: none;
    }
    .smallmap {
      display: none;
    }
  }

  .small-info1 {
    padding-bottom: 180px;
    position: relative;
    .small-info1-info {
      padding: 20px 15px 30px 18px;
      position: absolute;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
      background-color: #fff;
      font-size: 11px;
      border: 1px solid #258ffc;
      box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2);
      color: #323232;
    }
  }

  .product-info1 {
    position: relative;
    width: 100%;
    height: 836px;
    margin-bottom: 60px;
    img {
      width: 100%;
      height: 100%;
    }
    .tt {
      width: 100%;
      position: absolute;
      top: 118px;
      left: 0;
      color: #fff;
      text-align: center;
      font-size: 36px;
      p {
        font-size: 24px;
      }
    }
    .product-info1-info1 {
      position: absolute;
      width: 63%;
      height: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 1);
      display: flex;
      min-width: 1200px;
      .product-info1-info2 {
        width: 40%;
        height: 100%;
        background: rgba(37, 143, 252, 1);
        padding: 20px;
        position: relative;
        img {
          width: 100%;
          height: 90%;
          position: absolute;
          right: -25px;
          top: 5%;
        }
      }
      .product-info1-info3 {
        width: 60%;
        height: 100%;
        background: rgba(255, 255, 255, 1);
        padding: 44px 34px;
        font-size: 18px;
        line-height: 22px;
        overflow: hidden;
        color: #3f404e;
      }
    }
  }
  .product-info2 {
    width: 20%;
    font-size: 28px;
    font-family: MicrosoftYaHei;
    font-weight: bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    @media screen and (max-width: 850px) {
      display: none;
    }
  }
  .product-info3 {
    width: 20%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    // font-weight: bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    @media screen and (max-width: 850px) {
      display: none;
    }
  }
  .product-info4 {
    width: 100%;
    height: 346px;
    margin: 0 auto;
    margin-top: 60px;
    text-align: center;
    img {
      width: 100%;
      max-width: 1495px;
      transform: translateX(60px);
    }
  }
  .dispose-info8 {
    width: 60%;
    margin: 0 auto;
    margin-bottom: 80px;
    display: flex;
    justify-content: space-between;
    div {
      width: 20%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border: 1px solid rgba(51, 51, 51, 1);
      border-radius: 100px;
      cursor: pointer;
    }
    .isactive {
      color: rgba(37, 143, 252, 1);
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(37, 143, 252, 1);
    }
  }
  .zhaoping {
    margin-bottom: 40px;
    height: 230px;
    line-height: 25px;
    padding-left: 150px;
  }
  .dispose-info88 {
    width: 180px;
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    margin-bottom: 100px;
    text-align: center;
    color: #fff;
    background: #258ffc;
    border: 1px solid rgba(37, 143, 252, 1);
    font-size: 24px;
    cursor: pointer;
    &:hover {
      p {
        display: block;
      }
    }
    p {
      display: none;
      line-height: 25px;
      margin-top: 20px;
      color: #323232;
      font-size: 18px;
    }
  }

  // 移动端
  .smallbox {
    h2 {
      font-size: 16px;
      color: #2e2e2e;
      font-weight: 400;
      margin: 11px 0;
      position: relative;
      padding-left: 28px;

      &::after {
        content: "";
        background-color: #258ffc;
        border-radius: 5.5px;
        width: 4px;
        height: 16px;
        overflow: hidden;
        position: absolute;
        top: 3px;
        left: 13px;
      }
    }
    .smallbox-info {
      margin-top: 25px;
      .smallbox-info-t {
        text-align: center;
        img {
          width: 40%;
        }
        span {
          display: block;
          text-align: center;
          margin: 30px auto;
          line-height: 25px;
          width: 75px;
          height: 25px;
          border-radius: 12px;
          background-color: #258ffc;
          color: #fff;
        }
      }
      .smallbox-info-b {
        padding: 0 35px;
        b {
          font-size: 12px;
          font-weight: 400;
        }
        p {
          font-size: 12px;
          margin-top: 10px;
        }
      }
    }
  }
  .dispose-info888 {
    width: 100%;
    height: 150px;
    background: rgba(240, 239, 239, 1);
    padding-top: 120px;
  }
  .dispose-info9 {
    width: 100%;
    height: 680px;
    background: rgba(240, 239, 239, 1);
    // margin-bottom: 120px;
    ul {
      width: 60%;
      // height: 350px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding-top: 91px;

      min-width: 1140px;
      li {
        width: 30%;
        height: 415px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        box-shadow: 0px 0px 18px #ccc;
        cursor: pointer;
        div {
          width: 90px;
          height: 90px;
          margin: 0 auto;
          margin-top: 80px;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        h5 {
          text-align: center;
          line-height: 40px;
          font-size: 24px;
          color: #3f404e;
          font-weight: 400;
          margin-bottom: 40px;
        }
        p {
          font-size: 16px;
          line-height: 20px;
          text-align: center;
          color: #3f404e;
        }
        &:hover {
          transform: scale(1.02);
          transition: all 0.2s linear;
        }
      }
    }
  }

  // 移动端
  .smallshili {
    padding-top: 60px;

    h2 {
      font-size: 16px;
      color: #2e2e2e;
      font-weight: 400;
      margin: 11px 0;
      position: relative;
      padding-left: 28px;

      &::after {
        content: "";
        background-color: #258ffc;
        border-radius: 5.5px;
        width: 4px;
        height: 16px;
        overflow: hidden;
        position: absolute;
        top: 3px;
        left: 13px;
      }
    }

    .swiper-slide {
      padding: 0 15px;
      .slidebox {
        padding: 30px 10px;
        border: 1px solid #258ffc;
        height: 180px;
        p {
          text-align: center;
          font-size: 12px;
          img {
            width: 37px;
            height: 37px;
          }
          &:nth-of-type(2) {
            margin: 10px;
          }
        }
      }
    }
    .swiper-pagination {
      width: 100%;
      /deep/.swiper-pagination-bullet {
        height: 2px;
      }
    }
  }
  .dispose-info10 {
    width: 63%;

    margin: 0 auto;
    margin-top: 60px;
    display: flex;
    min-width: 1140px;
    box-shadow: 1px 5px 10px #f0f4fd;
    .dispose-info11 {
      width: 58%;
      height: 350px;
      .bm-view {
        width: 100%;
        height: 350px;
      }
      background: rgba(37, 143, 252, 1);
      overflow: hidden;
      cursor: pointer;
      &:nth-of-type(2) {
        padding-left: 30px;
        height: 332px;
        margin-top: 10px;
      }
      img {
        width: 100%;
        height: 100%;
        // padding: 10px;
      }
      p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 4px;
        color: rgba(255, 255, 255, 1);
        padding: 20px;
        &:nth-of-type(1) {
          margin-top: 60px;
        }
      }
    }
  }
  .smallmap {
    h2 {
      font-size: 16px;
      color: #2e2e2e;
      font-weight: 400;
      margin: 11px 0;
      position: relative;
      padding-left: 28px;

      &::after {
        content: "";
        background-color: #258ffc;
        border-radius: 5.5px;
        width: 4px;
        height: 16px;
        overflow: hidden;
        position: absolute;
        top: 3px;
        left: 13px;
      }
    }
    .bm-view {
      width: 100%;
      height: 300px;
    }
  }
}
</style>

